import { useFeatureToggle } from '@/context/featureToggles'
import AiSearchBox from '@/widgets/AiSearchBox'
import SearchBox from '@/widgets/SearchBox'
import { CSSTransition } from 'react-transition-group'
import * as styles from './style'

export interface Props {
  menuVisible: boolean
}

const SearchMenu = ({ menuVisible }: Props): JSX.Element => {
  const aiSearchBoxEnabled = useFeatureToggle('ai_search_box')
  return (
    <CSSTransition in={menuVisible} timeout={300} unmountOnExit classNames="searchBox">
      <nav className={styles.menuWrapper}>{!aiSearchBoxEnabled ? <SearchBox isSmallDevice /> : <AiSearchBox />}</nav>
    </CSSTransition>
  )
}

export default SearchMenu
